'use client';

import type { FC } from 'react';
import { Accordion, AccordionItem } from '@nextui-org/accordion';

type PropType = {
  items: { key: string; ariaLabel: string; title: string; indicator: JSX.Element; content: any }[];
};

const ProductAccordionBlock: FC<PropType> = ({ items }) => {
  return (
    <section className="product-additional-info">
      <div className="container">
        <Accordion isCompact variant="light" className="accordion">
          {items.map((item) => (
            <AccordionItem
              key={item.key}
              aria-label={item.ariaLabel}
              title={item.title}
              indicator={item.indicator}
            >
              {item.content}
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default ProductAccordionBlock;
